import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive  } from '@angular/router';
import { SharedDataService  } from '../../services/shared-data.service';
import { environment } from "../../../environments/environment";
import { AuthService } from '../../services/auth.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  private destroy$ = new Subject<void>();

  merchantName: string = '';
  merchantLogo: string = '';
  requiresRendition: boolean = false;
  billing: boolean = false;


  constructor(
    private router: Router,
    private sharedDataService: SharedDataService
  ) {}

  public ngOnInit() {
    this.setValues();
    this.sharedDataService.getMerchantName$().pipe(takeUntil(this.destroy$)).subscribe(
      (merchantName) => {
        console.log('SidebarComponent change values!');
        this.setValues();
      }
    );
  }

  setValues() {
    this.merchantName = localStorage.getItem('merchant_name');
    this.merchantLogo = localStorage.getItem('merchant_logo');

    const value = localStorage.getItem('requires_rendition');
    this.requiresRendition = value === 'true';

    const dashboard_features = localStorage.getItem('dashboard_features');
    if (dashboard_features) {
      const features = JSON.parse(dashboard_features);
      this.billing = features.includes('dashboard.charge.billing');
    }
  }

  public onSingOut() {
    localStorage.removeItem('auth.access_token');
    window.location.href = AuthService.getLoginAzureUrl();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
